import City from './City';
import Cuisine from './Cuisine';
import Neighbourhood from './Neighbourhood';
import Place from './Place';
import ResourceCollection from './ResourceCollection';

export default class PlaceWithTranslations extends Place {
  static collectionKey = 'places';

  constructor(
    id,
    name,
    subtitle,
    city,
    neighbourhood,
    address,
    description,
    slug,
    cuisines,
    priceRange,
    mealDuration,
    dinnerDuration,
    lat,
    lng,
    rateFood,
    rateService,
    rateAmbience,
    rateCount,
    freeTables,
    isFav,
    images,
    thumb,
    distance,
    prebookDuration,
    chefName,
    chefThumb,
    awardsList,
    isPermanentlyClosed,
    isRecommendedForBusinessMeetings,
    isRecommendedForRomanticDate,
    isRecommendedForWithKids,
    isRecommendedForBigGroups,
    acceptsOnlineBookings,
    contactPhoneNumber,
    kidsPlace,
    cardPay,
    wifi,
    parking,
    petFriendly,
    translations,
    accountManager,
    facebookPageLink,
    youtubeChannelLink,
    instagramProfileLink,
    tripadvisorPageLink,
    googleId,
    logo,
  ) {
    super(
      id,
      name,
      subtitle,
      city,
      neighbourhood,
      address,
      description,
      slug,
      cuisines,
      priceRange,
      mealDuration,
      dinnerDuration,
      lat,
      lng,
      rateFood,
      rateService,
      rateAmbience,
      rateCount,
      freeTables,
      isFav,
      images,
      thumb,
      distance,
      prebookDuration,
      chefName,
      chefThumb,
      awardsList,
      isPermanentlyClosed,
      isRecommendedForBusinessMeetings,
      isRecommendedForRomanticDate,
      isRecommendedForWithKids,
      isRecommendedForBigGroups,
      acceptsOnlineBookings,
      contactPhoneNumber,
      kidsPlace,
      cardPay,
      wifi,
      parking,
      petFriendly,
    );
    this._translations = translations;
    this._accountManager = accountManager;
    this._facebookPageLink = facebookPageLink;
    this._youtubeChannelLink = youtubeChannelLink;
    this._instagramProfileLink = instagramProfileLink;
    this._tripadvisorPageLink = tripadvisorPageLink;
    this._googleId = googleId;
    this._logo = logo;
  }

  get discounts() {
    return this._discounts;
  }

  get maxDiscount() {
    return Math.max(...this._discounts.map((discount) => discount.percent));
  }

  get translations() {
    return this._translations;
  }

  get facebookPageLink() {
    return this._facebookPageLink;
  }

  get youtubeChannelLink() {
    return this._youtubeChannelLink;
  }

  get instagramProfileLink() {
    return this._instagramProfileLink;
  }

  get tripadvisorPageLink() {
    return this._tripadvisorPageLink;
  }

  get googleId() {
    return this._googleId;
  }

  get logo() {
    return this._logo;
  }

  static fromAPI(object) {
    return new PlaceWithTranslations(
      object.id,
      object.name,
      object.subtitle,
      City.fromAPI(object.city),
      Neighbourhood.fromAPI(object.neighbourhood),
      object.address,
      object.description,
      object.slug,
      new ResourceCollection(Cuisine).make(object),
      object.price_range,
      object.meal_duration,
      object.dinner_duration,
      object.lat,
      object.lng,
      object.rate_food,
      object.rate_service,
      object.rate_ambience,
      object.rate_count,
      object.free_tables,
      object.is_fav,
      object.images,
      object.thumb,
      object.distance,
      object.prebook_duration,
      object.chef_name,
      object.chef_thumb,
      object.awards_list,
      object.is_permanently_closed,
      object.is_recommended_for_business_meetings,
      object.is_recommended_for_romantic_date,
      object.is_recommended_for_with_kids,
      object.is_recommended_for_big_groups,
      object.accepts_online_bookings,
      object.contact_phone_number,
      object.kids_place,
      object.card_pay,
      object.wifi,
      object.parking,
      object.pet_friendly,
      object.translations,
      object.account_manager,
      object.facebook_page_link,
      object.youtube_channel_link,
      object.instagram_profile_link,
      object.tripadvisor_page_link,
      object.google_id,
      object.logo,
    );
  }
}
